import PositionPref from "../../enums/position-pref";
import Pref from "./position-pref";

export default class KickedByPositionPref extends Pref {
    constructor(play, fragment) {
        super(play, fragment);
    }

    resolve() {
        return PositionPref.KICK;
    }
}
